import {makeAutoObservable} from "mobx";
import {IDeliveryResponse, IItems, IMeta} from "../core/models/Delivery";

class Delivery implements IDeliveryResponse {
    [Symbol.toStringTag] = this.constructor.name;
    private _items!: IItems[];
    private _meta!: IMeta;

    constructor() {
        makeAutoObservable(this);
    }

    get items() {
        return this._items;
    }

    set items(value: IItems[]) {
        this._items = value;
    }

    get meta() {
        return this._meta;
    }

    set meta(value: IMeta) {
        this._meta = value;
    }
}

export default Delivery;
